import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { FinancRp } from '../interfaces/financ-rp';
import { UnMedida } from '../interfaces/un-medida';
import { JwtAuthService } from './auth/jwt-auth.service';
import { Cadastro } from '../interfaces/cadastro';
import { FinancRpLctoBaixa } from '../interfaces/financ-rp-lcto-baixa';
import { FinancRpBaixa } from '../interfaces/financ-rp-baixa';

@Injectable({
  providedIn: 'root'
})
export class FinancRpLctoBaixaService {


  readonly path = '/financ/baixa';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(rps : FinancRp[]): Observable<FinancRpLctoBaixa> {
    return this.http.post<FinancRpLctoBaixa>(`${this.jwtAuthService.apiUrl + this.path}/calc`, rps);
  }

  recalcPorData(rps: FinancRp[], dataReferencia: string): Observable<FinancRpLctoBaixa> {
    return this.http.post<FinancRpLctoBaixa>(
      `${this.jwtAuthService.apiUrl + this.path}/calc/recalc-data`,
      rps,
      { params: { dataReferencia } }
    );
  }



  baixa(financRP: FinancRpLctoBaixa): Observable<FinancRpLctoBaixa> {
    console.log(`Baixar lista de RPS: ${financRP.financRps.map(rp => rp.id)}`);
    return this.http.put<FinancRpLctoBaixa>(`${this.jwtAuthService.apiUrl + this.path}/baixar`, financRP);
  }

  saveOrUpdateAndRecalc(cadastro: FinancRpLctoBaixa): Observable<FinancRpLctoBaixa[]> {
    return this.http.put<FinancRpLctoBaixa[]>(`${this.jwtAuthService.apiUrl + this.path}/recalc`, cadastro);
  }

  getParcelas(fatura: number ): Observable<FinancRpLctoBaixa[]> {
    return this.http.get<FinancRpLctoBaixa[]>(`${this.jwtAuthService.apiUrl + this.path}/lista/${fatura}`);
  }

  getItem(id: number ): Observable<FinancRpLctoBaixa> {
    return this.http.get<FinancRpLctoBaixa>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string, natureza = 'CREDITO', cadastro?:Cadastro): Observable<PageResult<FinancRpLctoBaixa>> {
    return this.http.get<PageResult<FinancRpLctoBaixa>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}&natureza=${natureza}&cadastroId=${cadastro?.id??-1}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string, natureza = 'CREDITO', cadastro?:Cadastro): Observable<PageResult<FinancRpLctoBaixa>> {
    return this.http.get<PageResult<FinancRpLctoBaixa>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}&natureza=${natureza}&cadastroId=${cadastro?.id??-1}`);
  }

  getBaixas(financRpId: number ): Observable<FinancRpBaixa[]> {
    return this.http.get<FinancRpBaixa[]>(`${this.jwtAuthService.apiUrl + this.path}/baixas/${financRpId}`);
  }

}
